module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"phone":"电话","address":"地址"},"ru":{"phone":"телефон","address":"адрес"}}')
  delete Component.options._Ctor
}
